import React from 'react';

/**
 * Explains why a field cannot be edited — shown under locked controls on edit forms.
 */
export default function LockedFieldNote({ children, className = '' }) {
    if (!children) return null;
    return (
        <p className={`field-note flex items-start gap-1.5 text-amber-900 bg-amber-50 border border-amber-200 rounded-md px-2.5 py-2 mt-1.5 ${className}`.trim()}>
            <svg
                className="w-4 h-4 mt-0.5 shrink-0 text-amber-700"
                fill="currentColor"
                viewBox="0 0 20 20"
                aria-hidden="true"
            >
                <path
                    fillRule="evenodd"
                    d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z"
                    clipRule="evenodd"
                />
            </svg>
            <span>{children}</span>
        </p>
    );
}
